import { withBemMod } from '@bem-react/core';
import React from 'react';

import HtmlContent from 'client/common/components/html-content';
import { ILevelAgency } from 'client/common/types';

import { b, ILevelProps } from '..';

import './level_type_agency.css';

export interface ILevelTypeAgencyProps extends Omit<ILevelAgency, 'type'> {
    type?: 'agency';
}

export const withLevelTypeAgency = withBemMod<ILevelTypeAgencyProps, ILevelProps>(
    b(),
    { type: 'agency' },
    (BaseLevel: React.FC<ILevelProps>) => props => {

        const { images, text, ...otherProps } = props;

        return (
            <BaseLevel {...otherProps}>
                <div className={b('content')}>
                    <HtmlContent className={b('text')} content={text} />
                    {images.length > 0 && (
                        <div className={b('images', { size: images.length })}>
                            {images.map(({ imageSrc, url }) => (
                                <div key={url} className={b('image')}>
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                        <img src={imageSrc} />
                                    </a>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </BaseLevel>
        );
    }
);
